<div class="pagination">
  <div class="pagination-size">
    <span class="pagination-label">Itens por página:</span>
    <cds-dropdown
      class="pagination-select"
      [options]="host.offsetOptions"
      [compact]="true"
      [formControl]="pageSizeControl"
      (optionSelected)="onPageSize($event)"
    />
  </div>

  <span class="pagination-range">
    {{ host.rangeStart }} - {{ host.rangeEnd }} de {{ host.totalItems }}
  </span>

  <div class="pagination-nav">
    <div class="pagination-buttons">
      <button
        type="button"
        class="pagination-arrow"
        aria-label="Primeira página"
        [disabled]="!host.canGoPrevious"
        (click)="host.navigate('first')"
      >
        <i class="cds-icon-double-arrow-left"></i>
      </button>
      <button
        type="button"
        class="pagination-arrow"
        aria-label="Página anterior"
        [disabled]="!host.canGoPrevious"
        (click)="host.navigate('previous')"
      >
        <i class="cds-icon-arrow-left"></i>
      </button>
    </div>

    <span class="pagination-page">
      Página <strong>{{ host.currentPageNumber }}</strong> de <strong>{{ host.totalPages }}</strong>
    </span>

    <div class="pagination-buttons">
      <button
        type="button"
        class="pagination-arrow"
        aria-label="Próxima página"
        [disabled]="!host.canGoNext"
        (click)="host.navigate('next')"
      >
        <i class="cds-icon-arrow-right"></i>
      </button>
      <button
        type="button"
        class="pagination-arrow"
        aria-label="Última página"
        [disabled]="!host.canGoNext"
        (click)="host.navigate('last')"
      >
        <i class="cds-icon-double-arrow-right"></i>
      </button>
    </div>
  </div>
</div>
